











































































































































































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import {Route} from 'vue-router'
import {Watch} from 'vue-property-decorator'
import {Getter, Mutation, State} from 'vuex-class'
import UserGroup from '@/modules/user/model/UserGroup'
import UserList from '@/modules/user/components/UserList.vue'
import User from '@/modules/user/model/User'
import {FindUserCriteria} from '@/modules/user/api'
import AddGroupUsers from '@/modules/user/components/UserGroup/AddGroupUsers.vue'
import {Colors, notify} from '@/modules/core/notification'
import Loader from '@/components/Loader.vue'
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import ConfirmDeleteUserGroup from '@/modules/user/components/UserGroup/ConfirmDeleteUserGroup.vue';
import {DateMixin} from '@/modules/core/date';
import {is} from 'tinymce';
import UserGroupWidget from '@/modules/app-router/components/UserGroupWidget.vue';
import {MutationTypes} from '@/modules/app-router/store/mutations'
import UserGroupList from '@/modules/user/components/UserGroup/UserGroupList.vue';

/**
 * Muestra una pantalla para editar el grupo de usuario seleccionado
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { ConfirmDeleteUserGroup, Loader, AddGroupUsers, UserList, UserGroupWidget, UserGroupList, },
})
export default class UserGroupDetail extends mixins(DateMixin) {
    public $refs: Vue['$refs'] & {
        users: {
            reload (): Promise<void>,
        },
        form: {
            validate (): boolean,
        },
    }

    /**
     * Grupo de usuarios seleccionado
     */
    @State(state => state.user.userGroup)
    public userGroup: UserGroup

    @State(state => state.user.selectedGroupUsers)
    public selectedUsers: User[]

    /**
     * Comprueba si el módulo argumentado se encuentra activo en la aplicación
     */
    @Getter('moduleIsEnabled')
    public moduleIsEnabled: (module: string) => boolean
    
    @Mutation('user/REMOVE_GROUP_FROM_CURRENT_GROUP')
    public removeGroup: (group: number) => void

    public loading = true
    public addUsers = false
    public deleteUsersConfirm = false
    public deletingUsers = false
    public saveConfirm = false
    public saving = false
    public confirmDelete = false
    public addGroupDialog = false
    public userListDisabled = true
    public userListFilters: FindUserCriteria = {
        includeGroups: [],
    }

    /**
     * Reglas de validación para el formulario
     */
    public rules: KeyValuePair<Array<(v: string) => boolean | string>> = {
        name: [
            v => !!v || 'El nombre del grupo es obligatorio',
        ],
    }

    destroyed () {
        // Asignar a la variable del estado validateGroupYesNotBeParent cero para no tener filtro de grupos a
        // mostrar lista de grupos en el componente UserGroupList.
        this.$store.commit(`user/SET_VALIDATE_GROUP_YES_NOT_BE_PARENT`, 0) 
    }

    public get customItems () {
        return this.userGroup.isNew ? this.userGroup.newUsers : null
    }

    /**
     * Observa la ruta para carga el grupo de usuarios en base al id argumentado
     *
     * @param route
     */
    @Watch('$route', {immediate: true})
    public async watchRoute (route: Route) {
        this.userListDisabled = true

        const id = route.params['id'] === 'nuevo' ? 0 : this.getIdEncode(route.params['id']) //atob(route.params['id'])
        await this.$store.dispatch('user/loadUserGroup', id)

        if (!this.userGroup.isNew) {
           this.userListDisabled = false
           this.userListFilters.includeGroups = [this.userGroup.id]
       }

        this.loading = false
    }

    public async deleteUsers () {
        this.deletingUsers = true
        await this.$store.dispatch('user/deleteGroupUsers')
        // La recarga no tendrá ningún efecto mientras el grupo de usuarios actual sea
        // nuevo.
        this.$refs.users.reload()

        this.deleteUsersConfirm = false
        this.deletingUsers = false

        notify('Los usuarios se han quitado del grupo correctamente')
    }


    /**
     * Guarda los cambios del grupo de usuarios
     */
    public async save () {
        this.saving = true
        const isNew = this.userGroup.isNew
        await this.$store.dispatch('user/saveUserGroup')
        await this.saveGroupReleaseAssignations()
        this.saveConfirm = false
        this.saving = false
        notify(`El grupo de usuarios ${this.userGroup.name} se ha guardado correctamente`)

        if (isNew) {
            await this.$router.replace({
                name: 'user-group',
                params: { id: this.userGroup.id.toString() },
            })
        }
    }

    public async deleteUserGroup () {
        return null
    }

    public errorCaptured (error: Error) {
        this.saving = false
        this.saveConfirm = false
    }

    /**
     * Se guarda la asignación de la version que hay en el selector seleccionado al grupo.
     */
    private async saveGroupReleaseAssignations(){
        const groupReleaseAssignation = this.$store.state.appRouter.groupReleaseAssignation
        if(!groupReleaseAssignation){
            return
        }
        
        const release = groupReleaseAssignation.release
        const group =   groupReleaseAssignation.group
        /* if(!release || !release.id || release.id < 1) {
            return;
        } */

        if(!group || !group.id || group.id < 1 || this.userGroup.id !== group.id) {
            return;
        }

        // Guardar en BD la asignación de la version al grupo para ser enrutado
        this.$store.commit(`appRouter/${MutationTypes.UpdateGroupReleaseAssignation}`, {group: group, release: release})  
        await this.$store.dispatch('appRouter/saveGroupReleaseAssignations')
    }

    public get notShowUsers(): boolean  {
        return (this.userGroup.children && this.userGroup.children.length > 0 ) //(!this.userGroup) || (this.userGroup.userCount > 0) 
    }

    public get isShowGroupChildrens(): boolean  {
        
        return (!(this.userGroup.parent) && this.isCanRegisterPlatformUser) //(!this.userGroup) || (this.userGroup.userCount > 0) 
    }
     public get isCanRegisterPlatformUser() {
         return (this.moduleIsEnabled('app-router'))
    }

    public showAsignarGrupo() {
        this.$store.commit(`user/SET_VALIDATE_GROUP_YES_NOT_BE_PARENT`, 2)  
        this.addGroupDialog = true;
    }

    private  getIdEncode(id: string | number) {
        // El ID es una ruta de acceso del arbol de grupos, se codifica en base64
        // para compatibilidad con rutas
        if(!this.isNumber(id)){ //if(typeof id == 'string'){
            return atob(id.toString())
        } else {
            return id
        }
    }

    private isNumber(value: string|number){
        var valoresAceptados = /^[0-9]+$/;
        return value.toString().match(valoresAceptados)
    }

    private selectedUserGroup(value: any){
        //if(event && event.length > 0 &&  event[0].id === this.userGroup.id){
        const foud = value.findIndex((g: UserGroup)  => {return g.id==this.userGroup.id})
        if( foud >  -1){
            notify(`No se puede asignar el grupo así mismo como hijo ${this.userGroup.name}`, Colors.Error)
            value.splice(foud,1);
        }
        this.$store.commit('user/UPDATE_USER_GROUP_FIELD', {field: 'children', value: value})
    }
}
